export default __webpack_public_path__ + "static/media/DSN Hackaton.cd106d48.png";